// config/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api1.ptbss.id/',
});

api.interceptors.request.use(
  (config) => {
    const access_token = localStorage.getItem('access_token');
    if (access_token) {
      config.headers['access_token'] = access_token;
      config.headers['Authorization'] = `Bearer ${access_token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
